import React from 'react';
import Modal from 'react-modal';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import OtpTable from './OtpTable';
import Theme from '../ui/Theme';

const useStyles = makeStyles(() => ({
  popupHeading: {
    fontSize: '18px',
    fontWeight: '600',
    lineHeight: '22px',
    fontStyle: 'normal',
    marginBottom: '10px',
    marginTop: '0px',
    paddingLeft: '18px',
  },
}));
const OtpDetailsPopup = (props) => {
  const classes = useStyles();
  return (
    <Modal
      isOpen
      onRequestClose={() => false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          backgroundColor: 'hsla(50, 33%, 25%, 0.35)',
        },
        content: {
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          border: 0,
          height: '600px',
          width: '930px',

          overflow: 'auto',
        },
        popupCloseBtn: {
          borderRadius: '50%',
          backgroundColor: Theme.palette.secondary.main,
          padding: '8px',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
          },
          cursor: 'pointer',
        },
      }}
    >
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={11}>
          <p className={classes.popupHeading}>OTP Details</p>
        </Grid>
        <Grid item xs={1}>
          <CloseIcon className={classes.popupCloseBtn} onClick={props.close} />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item style={{ marginTop: '10px', width: '100%' }}>
          <OtpTable />
        </Grid>
      </Grid>
    </Modal>
  );
};

export default OtpDetailsPopup;
